import { createWeb3Modal } from '@web3modal/wagmi/react'
import { WagmiConfig } from 'wagmi'
import { wagmiConfig, chains } from '../config/web3modal'

// Initialize Web3Modal
createWeb3Modal({
  wagmiConfig,
  projectId: 'cdc705e7053c640265c9e1619ea346c7',
  chains
})

export function Web3ModalProvider({ children }) {
  return (
    <WagmiConfig config={wagmiConfig}>
      {children}
    </WagmiConfig>
  )
}